
import { computed, defineComponent, ref } from 'vue'
import { CheckCircleIcon } from '@heroicons/vue/outline'
import { XIcon } from '@heroicons/vue/solid'
import { NotificationModalOptions } from '@/types/modalTypes'
import { EmitEvents } from '@/utils/emitHelpers'

export default defineComponent({
  name: 'NotificationModal',
  components: {
    CheckCircleIcon,
    XIcon
  },
  setup() {
    const message1 = ref('')
    const message2 = ref('')

    const clear = () => {
      message1.value = ''
      message2.value = ''
    }

    const setMessage = (options: NotificationModalOptions) => {
      message1.value = options.message1
      message2.value = options.message2
      setTimeout(clear, 5000)
    }

    let isValid = computed((): boolean => {
      return !!message1.value || !!message2.value
    })

    return {
      setMessage,
      clear,
      isValid,
      message1,
      message2
    }
  },
  mounted() {
    this.emitter.on(
      EmitEvents.ShowNotification,
      (options: NotificationModalOptions) => {
        this.setMessage(options)
      }
    )
  }
})
